import html from './editorial-activity.html';
import lang from './editorial-activity.lang.json';
import * as directives from '../../../../client/globals/directives.js';
import * as validators from '../../../../client/globals/validators.js';

export default {
    template: html,

    props: {
        data: Object,
        readonly: Boolean,
        v_state: Object,
    },

    mixins: [
        directives.label_required,
        validators.vuelidate
    ],

    i18n: {
        messages: lang
    },

    data() {
        let $t = this.$t.bind(this);
        return {
            role_options: Object.keys($t('roles')).map((key) => ({
                value: key,
                text: $t('roles')[key],
            })),
        };
    },

    mounted() {
        this.$emit('update:v_state', this.$v);
    },

    validations() {
        return {
            data: {
                publication: {
                    required: validators.required,
                },
                role: {
                    required: validators.required,
                },
                date_from: {
                    required: validators.required,
                    asis_date: validators.asis_date,
                },
                date_until: {
                    asis_date: validators.asis_date,
                },
                comments: {},
            },
        };
    },

    watch: {
        '$v.$invalid': function() {
            this.$emit('update:v_state', this.$v);
        },
    },
};
